const STORAGE_KEY = "inner_circle_pending_claim";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export interface PendingInnerCircleClaim {
	email: string;
	phoneNumber: string;
	resultIds: number[];
	returnPath: string;
	createdAt: number;
}

export function savePendingInnerCircleClaim(
	claim: Omit<PendingInnerCircleClaim, "createdAt">,
): void {
	sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...claim, createdAt: Date.now() }));
}

export function clearPendingInnerCircleClaim(): void {
	sessionStorage.removeItem(STORAGE_KEY);
}

export function readPendingInnerCircleClaim(): PendingInnerCircleClaim | null {
	const raw = sessionStorage.getItem(STORAGE_KEY);
	if (!raw) return null;
	try {
		const claim: PendingInnerCircleClaim = JSON.parse(raw);
		if (
			!claim ||
			typeof claim.email !== "string" ||
			typeof claim.phoneNumber !== "string" ||
			typeof claim.returnPath !== "string" ||
			!claim.returnPath.startsWith("/") || claim.returnPath.startsWith("//") ||
			!Array.isArray(claim.resultIds) || claim.resultIds.length === 0 ||
			!claim.resultIds.every((id) => Number.isInteger(id) && id > 0) ||
			typeof claim.createdAt !== "number" ||
			claim.createdAt > Date.now() || Date.now() - claim.createdAt >= MAX_AGE_MS
		) {
			throw new Error("The saved prize claim is invalid or has expired. Please claim your prize again.");
		}
		return claim;
	} catch (error) {
		clearPendingInnerCircleClaim();
		throw error;
	}
}
